import { IInstagramApi } from 'infrastructure/apis/instagram';
import { IInstagramService } from './IInstagramService';
import { InstagramPostMapper } from 'infrastructure/mappers/InstagramPost/InstagramPostMapper';
import { InstagramPost } from 'domains/instagramPost';
import { MediaUpdateDTO } from 'infrastructure/dtos/instagramPost';

export class InstagramService implements IInstagramService {
  constructor(private readonly api: IInstagramApi) {}

  async getInstagramPostsByUserId({ userId }: { userId: string }): Promise<InstagramPost[]> {
    const response = await this.api.getInstagramPostsByUserId({ userId });

    return response.posts.map(item => InstagramPostMapper.fromDTO(item));
  }

  async approvePost(body: {
    posts: {
      id: string;
      category_id: string;
      aspect_ratio: number;
    }[];
  }): Promise<unknown> {
    return await this.api.instagramPostsAdminAction({
      ...body,
      posts: body.posts.map(post => ({
        ...post,
        action: 'publish',
      })),
    });
  }

  async rejectPost(body: {
    posts: {
      id: string;
      category_id: string;
      reason?: string;
    }[];
  }): Promise<unknown> {
    return await this.api.instagramPostsAdminAction({
      ...body,
      posts: body.posts.map(post => ({
        ...post,
        action: 'reject',
      })),
    });
  }

  async updateMedia(body: MediaUpdateDTO): Promise<unknown> {
    return await this.api.instagramMediaUpdate(body);
  }
}
